import { render } from "./userssearch.vue?vue&type=template&id=19bf7ddf"
import script from "./userssearch.vue?vue&type=script&lang=js"
export * from "./userssearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__